import(/* webpackMode: "eager" */ "/codebuild/output/src4258496796/src/actions-runner/_work/eon-service/eon-service/frontend/apps/eon/src/app/error.tsx");
